import React from 'react';

import Background from './background.jsx';
import Footer from './footer.jsx';
import Header from './header.jsx';

import { LightboxProvider } from '$partials/base/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').PageShell}
 */
const PageShell = ({
    background = null,
    banner = false,
    children = null,
    footer = null,
    header = null,
    isParentHomePage = false
}) => {
    return (
        <LightboxProvider>
            {/* Fixed media background */}
            <Background {...background} />

            {/* Logo: Home Page */}
            {(isParentHomePage && header?.logoHomePage) && (
                <div className='layout-container home-page h-[calc(100dvh-125px)] sm:h-[calc(100dvh-96px)] relative'>
                    <img
                        alt={header.logoHomePage.alt}
                        className='absolute bottom-0 px-26 py-48 sm:px-40 sm:pb-42 sm:pt-78 pointer-events-none select-none box-content'
                        height={header.logoHomePage.height}
                        loading='eager'
                        src={header.logoHomePage.original}
                        width={header.logoHomePage.width} />
                </div>
            )}

            {/* Main trunk */}
            <div>
                {/* Header */}
                <Header
                    {...header}
                    footerLinks1={footer?.links1}
                    footerLinks3={footer?.links3}
                    footerLinks4={footer?.links4}
                    isParentHomePage={isParentHomePage} />

                <main id='main-content'>
                    {children}
                </main>

                {/* Banner and footer */}
                <Footer
                    {...footer}
                    banner={banner}
                    isParentHomePage={isParentHomePage} />
            </div>
        </LightboxProvider>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PageShell;
